import { useEffect, useState } from 'react';
import { Search, ChevronRight } from 'lucide-react';
import { appApi, entrarNoEspelho, ErroApp, type ContaEspelho } from './api';

// "Acessar como Contato" — a lista de quem da' pra espelhar ([DA-634]).
//
// Pedido dele, 27/08/2026: ver o app pela perspectiva do cliente pra achar falha e
// melhoria. Mora no ☰, ao lado da porta da equipe, e so aparece pra quem tem
// `papel = 'administrador'` no app (migration 0224) — o mesmo portao do "Entrar
// como loja", pelo mesmo motivo: **esconder nao e' trancar**, e quem recusa de
// verdade e' o servidor, em toda requisicao.
//
// ⚠️ **A entrada RECARREGA a pagina de proposito.** Trocar o token e re-renderizar
// deixaria de pe o que ja tinha sido montado com a identidade anterior — o
// `useAvisos` (que registra o service worker), o resumo em voo, a lista do chat.
// Recarregar refaz tudo a partir do `GET /me`, que e' de onde a tela inteira
// aprende quem ela esta mostrando.

const COBRE = '#b45309';

export function EspelhoContatos({ aoVoltar }: { aoVoltar: () => void }): React.ReactElement {
  const [contas, setContas] = useState<ContaEspelho[] | null>(null);
  const [busca, setBusca] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [entrando, setEntrando] = useState<number | null>(null);

  useEffect(() => {
    let vivo = true;
    appApi.espelhoContas()
      .then((c) => { if (vivo) setContas(c); })
      .catch((e) => { if (vivo) setErro(e instanceof ErroApp ? e.message : 'Nao consegui carregar a lista.'); });
    return () => { vivo = false; };
  }, []);

  async function entrar(c: ContaEspelho): Promise<void> {
    setErro(null);
    setEntrando(c.id);
    try {
      const s = await appApi.espelhar(c.id);
      entrarNoEspelho(s.token);
      window.location.reload();
    } catch (e) {
      setErro(e instanceof ErroApp ? e.message : 'Nao consegui abrir.');
      setEntrando(null);
    }
  }

  // Busca por nome OU telefone: na lista da loja um prestador as vezes e' lembrado
  // pelo numero (e' o que aparece no print que ele manda).
  const termo = busca.trim().toUpperCase();
  const visiveis = (contas ?? []).filter(
    (c) => !termo || c.nome.toUpperCase().includes(termo) || c.telefone.includes(termo.replace(/\D/g, '')),
  );

  return (
    <div>
      <p style={{ fontSize: 13.5, color: '#6b7280', lineHeight: 1.5, margin: 0, padding: '14px 16px 10px' }}>
        Abre o aplicativo com os olhos da pessoa, <strong>so pra ver</strong>. Nada e' gravado
        no nome dela, e Orcamentos e Agenda ficam fechados.
      </p>

      <div style={{ padding: '0 16px 12px', position: 'relative' }}>
        <Search size={16} style={{ position: 'absolute', left: 27, top: 15, color: '#9ca3af' }} />
        <input
          className="no-upper"
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
          placeholder="Procurar por nome ou celular"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          style={{
            width: '100%', height: 46, borderRadius: 10, border: '1px solid #d6d3d1',
            paddingLeft: 36, paddingRight: 12, fontSize: 15, backgroundColor: '#fff', color: '#111',
          }}
        />
      </div>

      {erro && (
        <div style={{ margin: '0 16px 12px', padding: '10px 12px', borderRadius: 8, backgroundColor: '#fef2f2', color: '#b91c1c', fontSize: 14 }}>
          {erro}
        </div>
      )}

      {contas === null && !erro && (
        <div style={{ padding: '18px 16px', fontSize: 14, color: '#6b7280' }}>Carregando...</div>
      )}

      {/* ⚠️ Lista vazia DIZ o filtro e a porta ([DA-468]): sumir calado leria como
          "nao ha contas", que e' outra coisa. */}
      {contas !== null && visiveis.length === 0 && (
        <div style={{ padding: '18px 16px', fontSize: 14, color: '#6b7280', lineHeight: 1.5 }}>
          {termo ? <>Ninguem com <strong>{busca.trim()}</strong> na lista. Apague a busca para ver todas.</> : 'Ainda nao ha contas no aplicativo.'}
        </div>
      )}

      {visiveis.map((c) => (
        <button
          key={c.id}
          type="button"
          disabled={entrando !== null}
          onClick={() => void entrar(c)}
          style={{
            width: '100%', display: 'flex', alignItems: 'center', gap: 12,
            padding: '14px 16px', backgroundColor: '#fff',
            borderBottom: '1px solid #e7e5e4', fontSize: 16, textAlign: 'left', color: '#111',
            opacity: entrando !== null && entrando !== c.id ? 0.5 : 1,
          }}
        >
          <span style={{ flex: 1, minWidth: 0 }}>
            <span style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {c.nome}
            </span>
            <span style={{ display: 'block', fontSize: 12.5, color: '#6b7280', marginTop: 2 }}>
              {entrando === c.id ? 'Abrindo...' : <Selos conta={c} />}
            </span>
          </span>
          <ChevronRight size={18} style={{ color: '#9ca3af', flexShrink: 0 }} />
        </button>
      ))}

      <div style={{ padding: 14 }}>
        <button
          type="button"
          onClick={aoVoltar}
          style={{ width: '100%', height: 46, borderRadius: 10, border: '1px solid #d6d3d1', backgroundColor: '#fff', color: '#44403c', fontSize: 15, fontWeight: 600 }}
        >
          Voltar
        </button>
      </div>
    </div>
  );
}

/**
 * O que a linha precisa dizer ANTES do toque.
 *
 * ⚠️ Os dois primeiros existem pra uma tela vazia nao ser lida como defeito: sem
 * ficha na loja, o Financeiro nao tem o que mostrar; sem conversa, o chat abre em
 * branco — e no espelho ele **continua** em branco, porque abrir ali nao cria
 * conversa nenhuma (é a diferenca entre o espelho e o cliente de verdade).
 */
function Selos({ conta }: { conta: ContaEspelho }): React.ReactElement {
  const partes: string[] = [mascararTelefone(conta.telefone)];
  if (!conta.ativo) partes.push('acesso desativado');
  if (!conta.tem_ficha) partes.push('sem ficha na loja');
  if (!conta.tem_conversa) partes.push('sem conversa');
  if (conta.papel === 'administrador') partes.push('administrador');
  return <>{partes.join(' · ')}</>;
}

/** `5564992597498` → `(64) 99259-7498`. O DDI sai: a lista e' toda do Brasil e ele
 *  so atrapalha a leitura rapida. */
function mascararTelefone(tel: string): string {
  const d = tel.replace(/\D/g, '').replace(/^55/, '');
  if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return tel;
}

export default EspelhoContatos;
